<template>
  <div class="minheight100" style="padding-bottom: 95px" v-if="dataDetail">
    <app-header v-if="appUser.isNative" title="友邻少年" :back-type="fromApp ? 'back-app' : null"></app-header>
    <div class="activity-main">
      <div class="pd20" v-if="dataDetail.activityStatus === 2">
        <div class="activity-title">
          <span class="tl"></span>
          活动已结束
          <span class="tr"></span>
        </div>
      </div>
      <div class="prelative">
        <div class="user flexdiv">
          <div class="userheader">
            <img :src="dataDetail.shareUserInfo.shareAvtarUrl" />
          </div>
          <div class="userinfo">
            <h3>{{ dataDetail.shareUserInfo.shareNickName }}</h3>
            <p>ID：{{ dataDetail.shareUserInfo.shareUserId }}</p>
          </div>
        </div>
      </div>
      <!-- <div class="activity-title" v-if="dataDetail.ruleType !== 'comm_none'">
      <span class="tl"></span>
      阅读营报名领好礼
      <span class="tr"></span>
    </div> -->
      <template v-if="dataDetail.ruleType === 'comm_credit' || dataDetail.ruleType === 'level_credit'">
        <div class="m16">
          <div class="card-award-2 card-award-border">
            <div class="jf">获得积分</div>
            <div class="card-border">
              <div class="card-con pd16 txt-center">
                <div class="con-txt">{{ dataDetail.totalCredit }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="m16" v-if="dataDetail.ruleType === 'level_goods'">
        <div class="my-swiper">
          <swiper :options="swiperOption" :key="swiperKey" ref="mySwiper" class="swiper">
            <swiper-slide v-for="(item, index) in dataDetail.activityRuleList" :key="index" class="swiper_item">
              <div class="card-award">
                <div class="card-border">
                  <div class="have" :class="{ haveno: item.obtainStatus === 0 }">{{ item.tagName }}</div>
                  <div class="card-con txt-center">
                    <div class="con-img">
                      <img :src="item.rewardIconUrl" />
                    </div>
                  </div>
                </div>
                <div class="zd zd-small">
                  {{ item.rewardName }}
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

      <div class="m16" v-if="dataDetail.ruleType.indexOf('level') > -1">
        <div class="progress">
          <div
            class="running"
            style="max-width: 100%"
            :style="{ width: Math.ceil((dataDetail.totalJoin / dataDetail.nextLimit) * 100) + '%' }"
          ></div>
        </div>
        <div class="progressinfo flexdiv average mt10">
          <div v-if="dataDetail.totalJoin < dataDetail.nextLimit">
            <font>再邀请</font>
            {{ dataDetail.nextLimit - dataDetail.totalJoin }}
            <font>人即可获得</font>
            {{ dataDetail.nextGoodsName }}
          </div>
          <div v-else>您已获得全部奖励</div>
          <div>{{ dataDetail.totalJoin }}/{{ dataDetail.nextLimit }}</div>
        </div>
      </div>
      <!-- <div class="pt16 activity-title">
      <span class="tl"></span>
      阅读营报名
      <span class="tr"></span>
    </div> -->
      <div class="m16 card-award-border">
        <div class="invite">
          <div class="pt16 activity-title">
            <span class="tl"></span>
            阅读营报名
            <span class="tr"></span>
          </div>
          <div class="title" v-if="dataDetail.recordList.length > 0">
            阅读营报名人数：{{ dataDetail.recordList.length }}
          </div>
          <div class="list">
            <ul v-if="dataDetail.recordList.length > 0">
              <li v-for="(item, index) in dataDetail.recordList" :key="index">
                <img :src="item.avtarUrl" />
                <div class="con">
                  <div class="flexdiv average mb5">
                    <h3>
                      {{ item.nickName }}
                    </h3>
                  </div>
                  <p>ID：{{ item.userId }}</p>
                </div>
                <div class="time">
                  {{ item.createTime.slice(0, -3) }}
                </div>
              </li>
            </ul>
            <div v-else class="nocon" style="padding: 30px 0">
              <img src="@/assets/images/no_list_1.png" style="margin-top: 0" />
              <p>邀请好友得好礼，助力孩子英语阅读！</p>
            </div>
          </div>
        </div>
      </div>
      <!-- v-if="dataDetail.ruleType !== 'comm_none' || dataDetail.cashBack === 1" -->
      <div class="fixed-bottom" v-if="false">
        <div class="flexdiv average">
          <div
            v-if="dataDetail.ruleType !== 'comm_none'"
            class="btn-common block"
            :class="{ 'btn-disabled': dataDetail.isObtainReward === false }"
            @click="dataDetail.isObtainReward === false ? null : handleClick()"
          >
            领取奖励
          </div>
          <div
            v-if="dataDetail.cashBack === 1"
            style="margin-left: 10px"
            class="btn-common block"
            :class="{ 'btn-disabled': dataDetail.showCashBtn === false }"
            @click="dataDetail.showCashBtn === false ? null : handleClickDeposit()"
          >
            提现
          </div>
        </div>
      </div>
    </div>
    <div class="activity-wx" @click="showWxClick" v-if="dataDetail.ruleType === 'comm_none'">联系客服</div>
    <van-popup v-model:show="wxshow" closeable position="bottom" :style="{ height: '320px' }">
      <div class="txt-center pd20 popupewm">
        <p class="color-black">{{ wxTitle || '添加客服微信领取奖励' }}</p>
        <div class="ewmcommon">
          <img :src="dataDetail.adviserErCode" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'

const action = 'activityProgress'

export default {
  name: '',
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide
  },
  data() {
    return {
      appUser,
      swiperKey: Math.random().toString(36).substr(2) /*随机的key*/,
      title: '查看进度和奖励',
      activityId: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      dataDetail: null,
      wxshow: false,
      wxTitle: '',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: '-5%',
        slidesPerView: 'auto',
        initialSlide: 0, //默认显示第一张在中心位置
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: false
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // }
      },
      pictureArr: [
        {
          picUrl: require('@/assets/images/logo.png')
        },
        {
          picUrl: require('@/assets/images/logo.png')
        }
      ],
      fromApp: null
    }
  },
  mixins: [Body],
  created() {
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity_progress?activityId=15
    this.activityId = this.$route.query.activityId
    this.shareUserId = appUser.userId
    this.fromApp = this.$route.query.fromApp
    console.log(appUser.userId)
    // // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  activated() {
    this.getData()
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    console.log(to) //当前
    console.log(from)
    next(e => {
      if (from.name !== 'activity' && !appUser.isNative) {
        e.$router.replace({
          path: '/activity',
          query: { activityId: e.activityId }
        })
      }
    })
  },

  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
      })
    },
    //进度
    getData() {
      if (!this.shareUserId) {
        this.$router.replace({
          path: '/activity',
          query: this.$route.query
        })
      }
      activityService
        .activityProgress({
          activityId: this.activityId,
          shareUserId: this.shareUserId
        })
        .then(res => {
          this.dataDetail = res
          //设置轮播图第一张的定位显示
          if (this.dataDetail.totalJoin >= this.dataDetail.nextLimit) {
            this.swiperOption.initialSlide = this.dataDetail.activityRuleList.length - 1
          } else {
            for (let i = 0; i < this.dataDetail.activityRuleList.length; i++) {
              if (this.dataDetail.activityRuleList[i].obtainStatus === 1) {
                this.swiperOption.initialSlide = i
              }
            }
          }
          this.$nextTick(() => {
            this.swiperKey = Math.random().toString(36).substr(2) //修改key，swiper重新渲染。
          })
        })
    },
    // // 设置分享数据
    // setShareData() {
    //   const { shareImg, shareMainTitle, shareSecondTitle } = this.dataDetail
    //   if (title) {
    //     return {
    //       title: shareMainTitle,
    //       desc: shareSecondTitle,
    //       link: location.href,
    //       imgUrl: shareImg
    //     }
    //   }
    // },
    //领取奖励
    handleClick() {
      this.wxTitle = '添加客服微信领取奖励'
      if (this.dataDetail.isObtainReward === true) this.wxshow = true
    },
    showWxClick() {
      this.wxshow = true
      this.wxTitle = '遇到问题，请联系客服'
    },
    handleClickDeposit() {
      this.$router.push({
        path: 'activity_deposit',
        query: { activityId: this.activityId, shareUserId: this.shareUserId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.activity-main {
  min-height: 100vh;
  background: #baf1d5 url(./images/activity_progress_bg.png) no-repeat;
  background-size: 100% AUTO;
  padding-bottom: 24px;
}
.my-swiper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 180px;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: visible !important;
  .swiper-wrapper .swiper-slide {
    width: 41.6%;
    border-radius: 8px;
    overflow: hidden;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}

.user {
  padding: 0.8rem 0.32rem 0.48rem;
  .userheader {
    border-radius: 50%;
    width: 48px;
    height: 48px;
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
  .userinfo {
    margin-left: 12px;
    font-size: 14px;
    padding: 4px 0;
    h3 {
      font-size: 18px;
      font-weight: bold;
    }
    p {
      margin-top: 10px;
    }
  }
}

.progress {
  background: rgba($color: #fff, $alpha: 0.3);
  position: relative;
  border-radius: 16px;
  height: 6px;
  .running {
    position: absolute;
    left: 0;
    width: 100%;
    height: 6px;
    background-color: #ffe4bc;
    border-radius: 16px;
  }
}
.progressinfo {
  color: #ffe4bc;
  font-weight: bold;
  font {
    opacity: 0.6;
    font-weight: normal;
  }
}
.invite {
  border-radius: 8px;
  padding: 20px 24px;
  background: #fff;
  .title {
    font-weight: bold;
    color: #999;
    margin: 12px 0 10px;
    text-align: center;
  }
  .list {
    border-radius: 8px;
    color: #333;
    position: relative;
    li {
      padding: 12px 0;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    .con {
      margin-left: 50px;
      padding: 4px;
      flex: 1;
    }
    h3 {
      font-size: 14px;
    }
    p {
      font-size: 12px;
    }
    .time {
      font-size: 12px;
    }
  }
}
.card-award-border {
  border: solid 1px #fff;
  position: relative;
  border-radius: 8px;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 8px;
    border: solid 8px #ddf8ea;
  }
}
.card-award-2 {
  background: url(./images/card-award-bg.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding: 28px 0 54px;

  .jf {
    font-size: 16px;
    font-weight: bold;
  }
  .con-txt {
    font-size: 48px;
    font-weight: bold;
    color: #00b25a;
    margin-top: 8px;
  }
}
.card-award {
  position: relative;
  height: 100%;
  .card-border {
    position: relative;
    height: 100%;
    border-radius: 6px;
    background-color: #dcad7e;
    padding: 6px;
    .have {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      border-bottom-right-radius: 8px;
      padding: 6px 10px;
      background-color: #fb5c51;
      color: #fff;
    }
    .haveno {
      background: #f1d7b0;
      color: #b9843a;
    }
    .card-con {
      position: relative;
      height: 100%;
      min-height: 120px;
      background-color: #fff8ee;
      border-radius: 6px;
      overflow: hidden;
    }
    .con-txt {
      margin-top: 20px;
      font-size: 36px;
      font-weight: bold;
      color: #fb5c51;
    }
    .con-img {
      position: relative;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .zd {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-image: url('./images/zd_small.png');
    background-size: 100% 100%;
    text-align: center;
    color: #974f07;
    font-weight: bold;
    font-size: 14px;
    padding-top: 22px;
  }
  .zd-big {
    background-image: url('./images/zd_big.png');
    height: 60px;
    padding-top: 30px;
  }
}
.activity-wx {
  width: 48px;
  height: 60px;
  position: fixed;
  bottom: 100px;
  right: 0;
  background: url(./images/activity_zjs_bg.png) no-repeat;
  background-size: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  padding: 14px 8px 14px 12px;
}
.activity-title {
  color: #000;
  font-size: 16px;
}
</style>
